export default (arrowColor, heading, scale, translate) => {
  return `<path d="M11.1969 15L11.1969 8.93128L15 8.93128L10.1103 4.04154L5.22051 8.93128L9.02364 8.93128L9.02364 15L11.1969 15Z" fill="#${arrowColor}" transform="translate(${translate}) scale(${scale}) rotate(${heading}, 10, 10)" />`;
};
